import React from 'react';
import { N80, N30 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export interface Props {
	/**
	 * Whether the color of the icon should be inverted.
	 */
	inverted?: boolean;
}

export const ReturnIcon: React.FunctionComponent<Props> = ({ inverted = false }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
		<g fill="none" fillRule="evenodd">
			<rect
				width="24"
				height="16"
				fill={
					inverted
						? token('color.background.neutral.bold', N80)
						: token('color.background.neutral', N30)
				}
				rx="3"
			/>
			<path
				fill={inverted ? token('color.icon.inverse', N30) : token('color.icon.subtle', N80)}
				fillRule="nonzero"
				d="M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
			/>
		</g>
	</svg>
);
